import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "h-inner" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "h-right" }
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "btn-refresh-count" }
const _hoisted_8 = {
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"opacity":".7"}
}
const _hoisted_9 = {
  key: 0,
  class: "docs-menu"
}
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_12 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_13 = {
  key: 0,
  class: "hf-wrap"
}
const _hoisted_14 = {
  key: 1,
  class: "h-user"
}
const _hoisted_15 = { class: "h-user-avatar" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "h-user-info" }
const _hoisted_18 = { class: "h-user-name" }
const _hoisted_19 = { class: "h-user-role" }
const _hoisted_20 = {
  key: 0,
  class: "h-atend-badge"
}
const _hoisted_21 = ["title"]
const _hoisted_22 = {
  width: "8",
  height: "8",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"opacity":".7"}
}
const _hoisted_23 = {
  key: 0,
  class: "h-avail-menu"
}
const _hoisted_24 = ["onClick", "disabled"]
const _hoisted_25 = {
  key: 0,
  class: "h-avail-error"
}
const _hoisted_26 = {
  key: 0,
  class: "h-avail-success"
}

import { ref, computed, watch, onMounted, onUnmounted } from 'vue'
import type { AuthUser } from '@/types/auth'
import InternalChatPopup from '@/components/InternalChatPopup.vue'
import { useTheme } from '@/composables/useTheme'
import { useAdmin } from '@/composables/useAdmin'
import { usePermission } from '@/composables/usePermission'
import { availStatus, updateAvailability, AVAIL_OPTIONS, syncAvailStatus } from '@/composables/useAvailability'
import { getAgent } from '@/services/wootdashAgents'
import { agentAvatarUrl, loadAgentAvatars, setAgentAvatar } from '@/composables/useAgentAvatars'
import { useLogo } from '@/composables/useLogo'
import { secondsUntilWarning, showWarning, triggerTestWarning } from '@/composables/useAutoLogout'
import { hiddenFluxoIdsCp, setHiddenFluxoIdsCp, setFlowCatalogCp, GENERAL_FLOW_NUMBER } from '@/composables/useHiddenFluxosCp'
import { useRailConversations } from '@/composables/useRailConversations'
import { listFlows, type CpFlow } from '@/services/wootdashSla'
import { useCurrentAgentRole } from '@/composables/useCurrentAgentRole'
import MultiSelectFilter from '@/components/dashboard/MultiSelectFilter.vue'
import { realtimeStatus, reconnectRealtime } from '@/composables/useConversationRealtime'

/** Selo de conexão: o que o agente vê bate com o que o socket está fazendo de verdade. */

export default /*@__PURE__*/_defineComponent({
  __name: 'DashHeader',
  props: {
    loading: { type: Boolean },
    lastUpdate: {},
    countdown: {},
    user: {},
    myCount: {},
    myOpenCount: {},
    myTeamFilter: { type: Boolean },
    myFluxosFilter: { type: Boolean }
  },
  emits: ["export", "logout", "testNotif", "toggleMyTeamFilter", "toggleMyFluxosFilter"],
  setup(__props: any) {

const liveState = computed(() => {
  switch (realtimeStatus.value) {
    case 'connected': return { kind: 'on', label: 'Ao vivo', hint: 'Conectado: tudo chega na hora, sem recarregar.' }
    case 'disconnected': return { kind: 'off', label: 'Sem conexão', hint: 'A conexão em tempo real caiu. Tentando de novo sozinho — ou clique em Reconectar.' }
    default: return { kind: 'wait', label: 'Reconectando…', hint: 'Restabelecendo a conexão em tempo real. O que chegar nesse meio-tempo aparece assim que voltar.' }
  }
})

const { logoUrl } = useLogo()

const props = __props



// O antigo botão "Atualizar" saiu: dados chegam pelo SignalR (e são rebuscados quando a conexão volta — selo
// "Ao vivo" acima) e versão nova é avisada pela faixa AppUpdateBanner.vue.

const { darkMode, toggleTheme } = useTheme()
const { profiles } = useAdmin()
const { can } = usePermission()
const canHideFluxo = computed(() => can('dashboard.hideFluxo'))

// Catálogo real de fluxos (Guid do WootDash, não o FLUXO_MAP numérico do Chatwoot) —
// carregado uma vez, junto do resto do que este header já busca no mount.
const flows = ref<CpFlow[]>([])
const { railConversations } = useRailConversations()
const fluxoHideOptions = computed(() => flows.value.map(f => ({
  id:    f.id,
  name:  f.name,
  // Geral (nº 1) também conta conversa sem fluxo — mesma regra do "Esconder Fluxo".
  count: railConversations.value.filter(c => c.flowId === f.id || (!c.flowId && f.number === GENERAL_FLOW_NUMBER)).length,
})))
const hiddenFluxoModel = computed({
  get: () => hiddenFluxoIdsCp.value,
  set: (v: Array<number | string>) => setHiddenFluxoIdsCp(v.map(String)),
})
const avatarError    = ref(false)
// Foto do próprio agente — o login não traz avatar (user.avatar_url fica ''); vem do mapa
// compartilhado, que o Meu perfil atualiza na hora ao trocar a foto.
const userAvatar     = computed(() => agentAvatarUrl(props.user?.wootdash_agent_id) ?? (props.user?.avatar_url || null))
watch(userAvatar, () => { avatarError.value = false })
// O cabeçalho está em toda página logada: carrega aqui as fotos de todos os agentes, que as
// telas com só agentId/agentName (conversas, avaliações, histórico) leem via agentAvatarUrl.
watch(() => props.user?.wootdash_token, t => { if (t) void loadAgentAvatars(t) }, { immediate: true })
const showTestBtn    = ref(false)
const showAutoLogoutTestBtn = ref(false)
const showAvailMenu  = ref(false)
const changingAvail  = ref(false)
const availWrap      = ref<HTMLElement | null>(null)
const availError     = ref('')
const availSuccess   = ref('')
const showDocsMenu   = ref(false)
const docsWrap       = ref<HTMLElement | null>(null)

const availLabelHeader = computed(() => {
  const map: Record<string, string> = { online: 'Online', busy: 'Ocupado', offline: 'Offline' }
  return map[availStatus.value] ?? availStatus.value
})

async function changeAvail(status: string) {
  if (!props.user?.wootdash_token) {
    availError.value = 'Sem token de acesso'
    setTimeout(() => { availError.value = '' }, 5000)
    return
  }
  showAvailMenu.value = false
  changingAvail.value = true
  availError.value   = ''
  availSuccess.value = ''
  try {
    await updateAvailability(props.user.wootdash_token, status as any)
    availSuccess.value = 'Status atualizado!'
    setTimeout(() => { availSuccess.value = '' }, 3000)
  } catch (e: any) {
    console.error('[DashHeader] Erro ao atualizar disponibilidade:', e)
    availError.value = e?.message || 'Erro ao atualizar'
    setTimeout(() => { availError.value = '' }, 8000)
  }
  changingAvail.value = false
}

function onDocClick(e: MouseEvent) {
  if (availWrap.value && !availWrap.value.contains(e.target as Node)) {
    showAvailMenu.value = false
  }
  if (docsWrap.value && !docsWrap.value.contains(e.target as Node)) {
    showDocsMenu.value = false
  }
}

function openDoc(file: string) {
  window.open(`/docs/${file}`, '_blank')
  showDocsMenu.value = false
}

function onKeyDown(e: KeyboardEvent) {
  // Ignora se o foco estiver em input/textarea
  const tag = (e.target as HTMLElement)?.tagName
  if (tag === 'INPUT' || tag === 'TEXTAREA') return
  if (e.key === '&') showTestBtn.value = !showTestBtn.value
  if (e.ctrlKey && e.key === '*') {
    e.preventDefault()
    showAutoLogoutTestBtn.value = !showAutoLogoutTestBtn.value
  }
}

// "Ativo!" enquanto o modal/toast já está em tela; senão mm:ss até disparar
// sozinho (null = auto-logout desativado ou rota isenta — sem contagem).
const autoLogoutCountdownLabel = computed(() => {
  if (showWarning.value) return 'Ativo!'
  if (secondsUntilWarning.value === null) return 'desativado'
  const total = secondsUntilWarning.value
  const mm = Math.floor(total / 60)
  const ss = total % 60
  return `${mm}:${String(ss).padStart(2, '0')}`
})

onMounted(async () => {
  document.addEventListener('keydown', onKeyDown)
  document.addEventListener('click', onDocClick)
  // Sincroniza disponibilidade real do usuário logado — Agent.Status é campo único e
  // real no WootDash (sem a duplicação Chatwoot `availability` vs. `availability_status`
  // computada por ActionCable que existia antes).
  if (props.user?.wootdash_token && props.user?.wootdash_agent_id) {
    try {
      const agent = await getAgent(props.user.wootdash_token, props.user.wootdash_agent_id)
      if (agent) {
        syncAvailStatus(agent.status)
        setAgentAvatar(agent.id, agent.avatarUrl)
      }
    } catch { /* silent */ }
  }
  if (props.user?.wootdash_token) {
    flows.value = await listFlows(props.user.wootdash_token)
    // Lista vazia = falha de rede (listFlows cai no default) — mantém o Geral já conhecido.
    if (flows.value.length) setFlowCatalogCp(flows.value)
  }
})
onUnmounted(() => {
  document.removeEventListener('keydown', onKeyDown)
  document.removeEventListener('click', onDocClick)
})

const initials = computed(() => {
  if (!props.user?.name) return ''
  return props.user.name
    .split(' ')
    .slice(0, 2)
    .map(w => w[0])
    .join('')
    .toUpperCase()
})

const currentProfile = computed(() => {
  if (!props.user) return null
  return profiles.value.find(p => p.userIds.includes(props.user!.id)) ?? null
})

// Papel real do WootDash (RBAC — config.role_permissions) tem prioridade sobre o
// perfil local antigo (useAdmin/admin_config, Chatwoot). Um agente com role "Sistema" no
// banco aparecia como "Agente" aqui porque esse perfil local nunca soube do RBAC novo —
// ver useCurrentAgentRole.ts. Só cai pro perfil local se o agente ainda não tiver papel
// nenhum atribuído no WootDash (fallback pras telas que só existiam no Chatwoot).
const { roleNames: cpRoleNames } = useCurrentAgentRole()
const roleLabel = computed(() => {
  if (cpRoleNames.value.length) return cpRoleNames.value.join(', ')
  if (!props.user) return ''
  if (currentProfile.value) return currentProfile.value.name
  return props.user.role === 'administrator' ? 'Administrador' : 'Agente'
})

// Perfil "EC - ISBET" (fallback) não tem time próprio no Chatwoot — troca o
// filtro "Meu Time" por "Meus Fluxos" (ver DashboardView.vue → myFluxosFilter).
const isEcIsbet = computed(() => currentProfile.value?.name === 'EC - ISBET')

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(logoUrl),
            alt: "ISBET",
            style: {"height":"100px","object-fit":"contain"}
          }, null, 8, _hoisted_3),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "logo-text" }, [
            _createElementVNode("div", { class: "logo-sub" }, "WootDash")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["live-badge", `live-badge--${liveState.value.kind}`]),
            role: "status",
            "aria-live": "polite",
            title: liveState.value.hint
          }, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "live-dot" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(liveState.value.label) + " ", 1),
            (liveState.value.kind === 'off')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "live-retry",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(reconnectRealtime) && _unref(reconnectRealtime)(...args)))
                }, "Reconectar"))
              : _createCommentVNode("", true)
          ], 10, _hoisted_5),
          _withDirectives(_createElementVNode("button", {
            class: "btn-notif-test",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('testNotif'))),
            title: "Testar notificação (& para esconder)"
          }, [...(_cache[15] || (_cache[15] = [
            _createElementVNode("svg", {
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" }),
              _createElementVNode("path", { d: "M13.73 21a2 2 0 0 1-3.46 0" })
            ], -1),
            _createElementVNode("span", null, "Testar Notif.", -1)
          ]))], 512), [
            [_vShow, showTestBtn.value]
          ]),
          _withDirectives(_createElementVNode("button", {
            class: "btn-notif-test",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_unref(triggerTestWarning) && _unref(triggerTestWarning)(...args)), ["stop"])),
            title: `Testar aviso de inatividade (Ctrl+Shift+* para esconder) — ${autoLogoutCountdownLabel.value}`
          }, [
            _cache[16] || (_cache[16] = _createElementVNode("svg", {
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("circle", {
                cx: "12",
                cy: "12",
                r: "10"
              }),
              _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
            ], -1)),
            _cache[17] || (_cache[17] = _createElementVNode("span", null, "Testar Inatividade", -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(autoLogoutCountdownLabel.value), 1)
          ], 8, _hoisted_6), [
            [_vShow, showAutoLogoutTestBtn.value]
          ]),
          _createElementVNode("button", {
            class: "btn-export",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('export')))
          }, [...(_cache[18] || (_cache[18] = [
            _createElementVNode("svg", {
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
              _createElementVNode("polyline", { points: "7 10 12 15 17 10" }),
              _createElementVNode("line", {
                x1: "12",
                y1: "15",
                x2: "12",
                y2: "3"
              })
            ], -1),
            _createElementVNode("span", null, "Exportar", -1)
          ]))]),
          _createElementVNode("div", {
            class: "docs-wrap",
            ref_key: "docsWrap",
            ref: docsWrap
          }, [
            _createElementVNode("button", {
              class: "btn-docs",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (showDocsMenu.value = !showDocsMenu.value), ["stop"])),
              title: "Abrir documentação"
            }, [
              _cache[20] || (_cache[20] = _createElementVNode("svg", {
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("path", { d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" }),
                _createElementVNode("path", { d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" })
              ], -1)),
              _cache[21] || (_cache[21] = _createElementVNode("span", null, "Docs", -1)),
              (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[19] || (_cache[19] = [
                _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
              ]))]))
            ]),
            _createVNode(_Transition, { name: "avail-menu" }, {
              default: _withCtx(() => [
                (showDocsMenu.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("button", {
                        class: "docs-opt",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (openDoc('dashboard-documentacao.html')))
                      }, [...(_cache[22] || (_cache[22] = [
                        _createElementVNode("svg", {
                          width: "13",
                          height: "13",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("path", { d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" }),
                          _createElementVNode("path", { d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" })
                        ], -1),
                        _createTextVNode(" Documentação ", -1)
                      ]))]),
                      _createElementVNode("button", {
                        class: "docs-opt",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (openDoc('guia-do-usuario.html')))
                      }, [...(_cache[23] || (_cache[23] = [
                        _createElementVNode("svg", {
                          width: "13",
                          height: "13",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("circle", {
                            cx: "12",
                            cy: "12",
                            r: "10"
                          }),
                          _createElementVNode("path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 2-3 4" }),
                          _createElementVNode("line", {
                            x1: "12",
                            y1: "17",
                            x2: "12.01",
                            y2: "17"
                          })
                        ], -1),
                        _createTextVNode(" Guia do Usuário ", -1)
                      ]))]),
                      _createElementVNode("button", {
                        class: "docs-opt",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (openDoc('manual-fluxos-bot.html')))
                      }, [...(_cache[24] || (_cache[24] = [
                        _createElementVNode("svg", {
                          width: "13",
                          height: "13",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("line", {
                            x1: "8",
                            y1: "6",
                            x2: "21",
                            y2: "6"
                          }),
                          _createElementVNode("line", {
                            x1: "8",
                            y1: "12",
                            x2: "21",
                            y2: "12"
                          }),
                          _createElementVNode("line", {
                            x1: "8",
                            y1: "18",
                            x2: "21",
                            y2: "18"
                          }),
                          _createElementVNode("circle", {
                            cx: "4",
                            cy: "6",
                            r: "1"
                          }),
                          _createElementVNode("circle", {
                            cx: "4",
                            cy: "12",
                            r: "1"
                          }),
                          _createElementVNode("circle", {
                            cx: "4",
                            cy: "18",
                            r: "1"
                          })
                        ], -1),
                        _createTextVNode(" Manual dos Fluxos de bot ", -1)
                      ]))])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 512),
          _createVNode(InternalChatPopup),
          _createElementVNode("button", {
            class: "btn-theme",
            title: _unref(darkMode) ? 'Mudar para tema claro' : 'Mudar para tema escuro',
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(toggleTheme) && _unref(toggleTheme)(...args)))
          }, [
            (!_unref(darkMode))
              ? (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[25] || (_cache[25] = [
                  _createStaticVNode("<circle cx=\"12\" cy=\"12\" r=\"5\" data-v-b11ba466></circle><line x1=\"12\" y1=\"1\" x2=\"12\" y2=\"3\" data-v-b11ba466></line><line x1=\"12\" y1=\"21\" x2=\"12\" y2=\"23\" data-v-b11ba466></line><line x1=\"4.22\" y1=\"4.22\" x2=\"5.64\" y2=\"5.64\" data-v-b11ba466></line><line x1=\"18.36\" y1=\"18.36\" x2=\"19.78\" y2=\"19.78\" data-v-b11ba466></line><line x1=\"1\" y1=\"12\" x2=\"3\" y2=\"12\" data-v-b11ba466></line><line x1=\"21\" y1=\"12\" x2=\"23\" y2=\"12\" data-v-b11ba466></line><line x1=\"4.22\" y1=\"19.78\" x2=\"5.64\" y2=\"18.36\" data-v-b11ba466></line><line x1=\"18.36\" y1=\"5.64\" x2=\"19.78\" y2=\"4.22\" data-v-b11ba466></line>", 9)
                ]))]))
              : (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[26] || (_cache[26] = [
                  _createElementVNode("path", { d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" }, null, -1)
                ]))]))
          ], 8, _hoisted_10),
          (canHideFluxo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(MultiSelectFilter, {
                  options: fluxoHideOptions.value,
                  modelValue: hiddenFluxoModel.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((hiddenFluxoModel).value = $event)),
                  placeholder: "Esconder Fluxo"
                }, null, 8, ["options", "modelValue"])
              ]))
            : _createCommentVNode("", true),
          (__props.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_router_link, {
                  to: "/profile",
                  class: "h-user-link",
                  title: "Meu perfil"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      (userAvatar.value)
                        ? _withDirectives((_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: userAvatar.value,
                            alt: __props.user.name,
                            class: "h-avatar-img",
                            onError: _cache[10] || (_cache[10] = ($event: any) => (avatarError.value = true))
                          }, null, 40, _hoisted_16)), [
                            [_vShow, !avatarError.value]
                          ])
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: _normalizeClass(["h-avatar-initials", { hidden: userAvatar.value && !avatarError.value }])
                      }, _toDisplayString(initials.value), 3),
                      _createElementVNode("span", {
                        class: _normalizeClass(["h-avail-badge", `h-avail-badge--${_unref(availStatus)}`])
                      }, null, 2)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(__props.user.name), 1),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(roleLabel.value), 1),
                      (__props.myOpenCount > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, [...(_cache[27] || (_cache[27] = [
                            _createElementVNode("svg", {
                              width: "9",
                              height: "9",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M3 18v-6a9 9 0 0 1 18 0v6" }),
                              _createElementVNode("path", { d: "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" })
                            ], -1),
                            _createTextVNode(" em atendimento ", -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", {
                  class: "h-avail-wrap",
                  ref_key: "availWrap",
                  ref: availWrap
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["h-avail-trigger", `h-avail-trigger--${_unref(availStatus)}`]),
                    onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (showAvailMenu.value = !showAvailMenu.value), ["stop"])),
                    title: `Disponibilidade: ${availLabelHeader.value}`
                  }, [
                    _cache[29] || (_cache[29] = _createElementVNode("span", { class: "h-avail-dot" }, null, -1)),
                    (_openBlock(), _createElementBlock("svg", _hoisted_22, [...(_cache[28] || (_cache[28] = [
                      _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
                    ]))]))
                  ], 10, _hoisted_21),
                  _createVNode(_Transition, { name: "avail-menu" }, {
                    default: _withCtx(() => [
                      (showAvailMenu.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(AVAIL_OPTIONS), (opt) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: opt.value,
                                class: _normalizeClass(["h-avail-opt", { 'h-avail-opt--active': _unref(availStatus) === opt.value }]),
                                onClick: ($event: any) => (changeAvail(opt.value)),
                                disabled: changingAvail.value
                              }, [
                                _createElementVNode("span", {
                                  class: "h-avail-opt-dot",
                                  style: _normalizeStyle({ background: opt.color })
                                }, null, 4),
                                _createTextVNode(" " + _toDisplayString(opt.label), 1)
                              ], 10, _hoisted_24))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ], 512),
                _createVNode(_Transition, { name: "avail-err" }, {
                  default: _withCtx(() => [
                    (availError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(availError.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_Transition, { name: "avail-err" }, {
                  default: _withCtx(() => [
                    (availSuccess.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(availSuccess.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createElementVNode("button", {
                  class: "btn-logout",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('logout'))),
                  title: "Sair"
                }, [...(_cache[30] || (_cache[30] = [
                  _createElementVNode("svg", {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }),
                    _createElementVNode("polyline", { points: "16 17 21 12 16 7" }),
                    _createElementVNode("line", {
                      x1: "21",
                      y1: "12",
                      x2: "9",
                      y2: "12"
                    })
                  ], -1)
                ]))])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "topbar" }, [
      _createElementVNode("div", { class: "topbar-inner" }, [
        _createElementVNode("span", null, [
          _createTextVNode("WootDash "),
          _createElementVNode("strong", null, "CRM"),
          _createTextVNode(" — Conversas em tempo real")
        ])
      ])
    ], -1))
  ], 64))
}
}

})